import router from '@/router';

router.addRoute({
	path: '/hotel/sadmin/drawer',
	name: 'Drawer',
	component: () => import('./View.vue'),
});
